import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const OpenXAgentLegalNote = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="body2">
        {t(
          'This Assistant is provided for general troubleshooting support only. Its responses may be incomplete, inaccurate, or mistaken and do not constitute legal advice, compliance advice, or an official OpenX position.'
        )}
      </Typography>
      <Typography variant="body2">
        {t(
          'Recommendations generated by the Assistant may touch on areas subject to legal, regulatory, or policy restrictions, including targeting, domains, creative limitations, and audience settings.'
        )}
      </Typography>
      <Typography variant="body2">
        {t(
          'Certain categories of targeting and advertising, including diversity, demographic, health, political, and other sensitive categories, may be prohibited or restricted depending on the sector, jurisdiction, and context, particularly in the credit, insurance, employment, and housing sectors, and may require additional legal review and safeguards. OpenX also maintains strict requirements relating to under-13 traffic, teen data, and child-directed properties, including traffic restrictions and processing limitations.'
        )}
      </Typography>
      <Typography variant="body2">
        {t(
          "You should not rely on the Assistant's recommendations without applying independent judgment and, where appropriate given the limitations described above, consulting your account manager or contacting the OpenX Legal team at"
        )}{' '}
        <Link href="mailto:legal@openx.com" underline="hover">
          legal@openx.com
        </Link>
        .
      </Typography>
    </Box>
  );
};
